/**
 * Created by vladislav on 9/6/2022
 */

const Yandex = function () {
    Platform.call(this, connector.YANDEX, {
        sdk: SdkManager.SDK_YANDEX
    });

    connector.social.needWindowForLogin = true;
};

Yandex.prototype = Object.create(Platform.prototype);
Yandex.prototype.constructor = Yandex;

Yandex.prototype._initialize = function (callback) {
    connector.info.playhop = window.location.href.indexOf("playhop.com") !== -1;

    callback();
};

Yandex.prototype._connect = function (callback) {
    ysdk.feedback.canReview().then((res) => {
        this.canReviewGame = res.value;
    });

    connector.info.changeLanguage(this._getSuggestedLanguage());

    callback(connector.STATUS_CONNECTED);
};

Yandex.prototype._loadPlayerObject = function () {
    if (this.player) {
        return Promise.resolve();
    }

    return ysdk.getPlayer({ signed: true }).then((player) => {
        this.player = player;
    });
};

Yandex.prototype.loadData = function () {
    return this._loadPlayerObject().then(() => this.player.getData());
};

Yandex.prototype.setData = function () {
    return this.player.setData(connector._platformStorage.data);
};

Yandex.prototype.notifyGameReady = function () {
    if (typeof ysdk !== "undefined" && ysdk.features && ysdk.features.LoadingAPI) {
        ysdk.features.LoadingAPI.ready();
    }
};

Yandex.prototype.getLocalStoragePrefix = function () {
    return "_yandex";
};

Yandex.prototype._getSuggestedLanguage = function () {
    if (typeof ysdk !== "undefined" && ysdk.environment.i18n) {
        return ysdk.environment.i18n.lang;
    }

    if (connector.info.playhop) {
        return connector.LANGUAGE_ENGLISH;
    }

    return connector.LANGUAGE_RUSSIAN;
};

// Yandex hands the "payload" search param of a game link to the opened game as ysdk.environment.payload.
// Cross promo puts the bare channel there; a switchGame payload with a crossId or promo travels as JSON
// holding channel plus Platform.CROSSPROMO_PAYLOAD_FIELDS (JSON.stringify drops the ones that are undefined).
Yandex.prototype._parsePayload = function (callback) {
    this.whenConnected(() => {
        const payload = ysdk.environment.payload;

        if (payload && payload.startsWith("{") && payload.endsWith("}")) {
            try {
                const data = JSON.parse(payload);
                callback(data);
                return;
            } catch (e) {
                console.log(`Can't parse payload: ${payload}`, e);
            }
        }

        callback({
            channel: payload
        });
    });
};

Yandex.prototype.canPassPayload = function () {
    return true;
};

Yandex.prototype.switchGame = function (url, payload) {
    if (url && payload && (payload.crossId || payload.promo)) {
        const channel = payload.channel || new URL(url).searchParams.get("payload") || undefined;

        const data = { channel };
        Platform.CROSSPROMO_PAYLOAD_FIELDS.forEach((key) => {
            data[key] = payload[key];
        });

        url = connector.utils.addSearchParams(url, {
            payload: JSON.stringify(data)
        });
    }

    Platform.prototype.switchGame.call(this, url);
};

Yandex.prototype.canReview = function () {
    return this.canReviewGame;
};

Yandex.prototype._requestReview = function (callback) {
    ysdk.feedback.requestReview().then((res) => {
        callback(res.feedbackSent ? connector.CODE_SUCCEED : connector.CODE_FAILED);
    });
};

Yandex.prototype.listGames = function () {
    return ysdk.features.GamesAPI.getAllGames().then(({ games }) => games.map((game) => ({
        appID: game.appID,
        imageURL: game.coverURL,
        iconURL: game.iconURL,
        title: game.title,
        link: game.url
    }))).catch((err) => {
        console.error("[connector] Yandex.listGames error", err);

        return [];
    });
};

Yandex.prototype.canSwitchGame = function () {
    return true;
};
